const numeroOuZero = (valor) =>
  valor === null || valor === undefined || valor === "" ? 0 : Number(valor);

const invalido = (erro) => ({
  valido: false,
  erro,
  creditoIcms: null,
  custoLiquido: null,
  percentualTotalVenda: null,
  precoVendaSugerido: null,
});

export function calcularPrecoVendaAssistente({
  custo,
  icmEntrada,
  icmSaida,
  custoOperacional,
  outrosImpostos,
  comissao,
  lucro,
}) {
  const custoProduto = Number(custo);

  const percentuais = [
    icmEntrada,
    icmSaida,
    custoOperacional,
    outrosImpostos,
    comissao,
    lucro,
  ].map(numeroOuZero);

  if (!Number.isFinite(custoProduto) || custoProduto <= 0) {
    return invalido("Informe um custo do produto maior que zero.");
  }

  if (percentuais.some((valor) => !Number.isFinite(valor) || valor < 0)) {
    return invalido("Os percentuais devem ser valores iguais ou maiores que zero.");
  }

  const [
    icmsRecuperavel,
    icmsVenda,
    custoOperacionalVenda,
    outrosImpostosVenda,
    comissaoVenda,
    lucroDesejado,
  ] = percentuais;

  if (icmsRecuperavel >= 100) {
    return invalido("O ICMS recuperável deve ser menor que 100% do custo.");
  }

  const creditoIcms = (custoProduto * icmsRecuperavel) / 100;
  const custoLiquido = custoProduto - creditoIcms;

  const percentualTotalVenda =
    icmsVenda +
    custoOperacionalVenda +
    outrosImpostosVenda +
    comissaoVenda +
    lucroDesejado;

  const precoVendaSugerido = custoLiquido * (1 + percentualTotalVenda / 100);

  return {
    valido: true,
    erro: null,
    creditoIcms,
    custoLiquido,
    percentualTotalVenda,
    precoVendaSugerido,
  };
}
